import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import {
  Container,
  Content,
  FormContainer,
  TitleSection,
  Row,
  Label,
  Col,
} from './styles';

import ExceptionsBox from '~/components/ExceptionsBox';
import { dataKeys } from '../../data/dataKeys';
import { dataKeysExceptions } from '../../data/dataKeysExceptions';
import GridResult from '../../GridResult';

const FormDataResult = ({ data, errorCompetence, errorCnes }) => {
  const [formData, setFormData] = useState(null);

  const [exceptions, setExceptions] = useState(null);

  const { errorData } = useSelector(state => state.generalIndicator);
  const { systemConfig } = useSelector(state => state.auth);
  const { mesDeCompetencia } = systemConfig;

  useEffect(() => {
    if (errorData) {
      const allErrors = errorData?.fields?.map(field =>
        dataKeysExceptions(field)
      );

      setExceptions(allErrors);
    }
  }, [errorData]);

  useEffect(() => {
    const dataFromFile = dataKeys(data);
    setFormData(dataFromFile);
  }, [data]);

  return (
    <Container>
      <Content>
        {errorCompetence || errorCnes || errorData ? (
          <h3 className="error">
            <span>Atenção:</span> Confira as
            <span> inconsistências do arquivo</span>
            <br />
            antes de alterar o arquivo existente.
          </h3>
        ) : (
          <h3>
            <span>Confira as informações abaixo</span> antes de
            <br /> enviá-las ao painel de indicadores.
          </h3>
        )}

        {exceptions && <ExceptionsBox exceptions={exceptions} />}
      </Content>

      <FormContainer>
        <TitleSection> {'>'} Informações de envio</TitleSection>
      </FormContainer>

      <GridResult fileData={data} />
    </Container>
  );
};

export default FormDataResult;
export { FormDataResult };
